import React, { useMemo } from "react";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { IconButton, Stack, Typography } from "@mui/material";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";
import { UiMeasureDataFiles } from "store/types";

import { IGroupsFormContext } from "./GroupsFormContext";

interface Props {
  isTotal: boolean;
  isMeasureGlobalValue: boolean;
  files: UiMeasureDataFiles | null;
  setMeasureDataFilesPickerParam: IGroupsFormContext["setMeasureDataFilesPickerParam"];
  group_id: number | null;
  measureDataKey: number | null;
  roundId: string | number | null;
}

export const AttachFiles: React.FC<Props> = ({
  isTotal,
  isMeasureGlobalValue,
  files,
  setMeasureDataFilesPickerParam,
  group_id,
  measureDataKey,
  roundId
}) => {
  const filesCount =
    (files?.dbFiles ? Object.keys(files.dbFiles).length : 0) +
    (files?.localFiles ? Object.keys(files.localFiles).length : 0);

  const tooltipTitle = useMemo(() => {
    if (isTotal) {
      return "Attach files that support the total (aggregate) amount.";
    }
    if (isMeasureGlobalValue) {
      return "Attach files to the global value measure.";
    }
    return "Attach files to this investor line.";
  }, [isTotal, isMeasureGlobalValue]);

  return (
    <MaterialTooltip isShow title={tooltipTitle}>
      <IconButton
        sx={{
          mt: "6px",
          "&:hover": {
            backgroundColor: "transparent"
          }
        }}
        onClick={() => {
          setMeasureDataFilesPickerParam({
            key: measureDataKey,
            groupId: group_id || null,
            files: {
              localFiles: files?.localFiles || null,
              dbFiles: files?.dbFiles || null
            },
            isTotal,
            roundId
          });
        }}
      >
        <Stack direction="row" alignItems="center">
          <DescriptionOutlinedIcon sx={{ color: filesCount ? "#26A6AE" : "inherit" }} />
          {Boolean(filesCount) && <Typography sx={{ color: "#26A6AE", mt: "6px" }}>+{filesCount}</Typography>}
        </Stack>
      </IconButton>
    </MaterialTooltip>
  );
};
